/**
 * Droits de l'utilisateur connecté, pour décider quels boutons montrer.
 *
 * Lire `useAuth()` abonne l'écran à l'état de connexion : une connexion ou une déconnexion
 * recalcule les droits. Un simple rafraîchissement de jeton ne change pas cet état, mais le
 * décodage est refait à chaque affichage, donc le prochain rendu les relit.
 *
 * Affichage seulement : l'API refuse toute action sans le droit (voir `domaine/droits.ts`).
 */
import { droitsCourants } from '../api/client';
import {
  droitsBons,
  droitsGammes,
  droitsParc,
  droitsPlanning,
  type DroitsBons,
  type DroitsGammes,
  type DroitsParc,
  type DroitsPlanning,
} from '../domaine/droits';
import { useAuth } from './AuthContext';

/** Droits sur les gammes d'entretien, les prix et les compteurs. */
export function useDroitsGammes(): DroitsGammes {
  useAuth();
  return droitsGammes(droitsCourants());
}

/** Droits sur les bons d'intervention saisis au bureau. */
export function useDroitsBons(): DroitsBons {
  useAuth();
  return droitsBons(droitsCourants());
}

/** Droits sur les machines du parc (lot T4 : valider, fusionner). */
export function useDroitsParc(): DroitsParc {
  useAuth();
  return droitsParc(droitsCourants());
}

/** Droits sur le planning : le lire, le gérer. */
export function useDroitsPlanning(): DroitsPlanning {
  useAuth();
  return droitsPlanning(droitsCourants());
}
